module.exports = __webpack_public_path__ + "img/mlw-logo.b440ae9d.webp";